// import node module libraries
import React from 'react';
import { Menu } from 'react-feather';
import { Link } from 'react-router';
import { Nav, Navbar, Form, Button } from 'react-bootstrap';

// import sub components
import QuickMenu from '../../layouts/QuickMenu';
import { isBooleanTrue } from '../../utils/objectUtils';

const HeaderDefault = (props) => {
	return (
		<React.Fragment>
			<Navbar expanded="lg" className="navbar-default">
				<div className="d-flex justify-content-between w-100">
					<div className="d-flex align-items-center">
						<Button variant="white" id="nav-toggle" onClick={() => props.data.SidebarToggleMenu(!props.data.showMenu)}>
							<Menu size="18px" />
						</Button>
						{props.data.showSearch ? (
							<div className="ms-lg-3 d-none d-md-none d-lg-block">
								{/* <!-- Form --> */}
								<Form className="d-flex align-items-center">
									<span className="position-absolute ps-3 search-icon">
										<i className="fe fe-search"></i>
									</span>
									<Form.Control type="search" className="form-control ps-6" placeholder="Search Entire Dashboard" />
								</Form>
							</div>
						) : null}
						{props.data.title ? (
							<div className="ms-lg-3 d-none d-sm-block">
								<span className="fw-bold fs-3">{props.data.title}</span>
							</div>
						) : null}
					</div>
					<Nav className="navbar-nav navbar-right-wrap ms-auto d-flex align-items-center nav-top-wrap">
						<QuickMenu showBackToHome={isBooleanTrue(props?.data?.showBackToHome)} />
					</Nav>
				</div>
			</Navbar>
		</React.Fragment>
	);
};

export default HeaderDefault;